import { isEmpty } from 'lodash';

import { ClaimContext, PersonData } from '~/components/Claim/ClaimInfo/types';

const buildFullName = (insured: PersonData) => {
  if (!insured?.first_name) return '';

  return `${insured.first_name}${insured.last_name ? ` ${insured.last_name}` : ''}`;
};

interface InfoItem {
  label: string;
  value: string;
}

const createInfoItem = (label: string, value: string, fallback = 'N/A'): InfoItem => ({
  label,
  value: value || fallback,
});

export const claimInfoToTopBar = (claimInfo: ClaimContext | null): Record<string, InfoItem> => {
  if (!claimInfo) return {};

  const { policy, date_of_loss, status } = claimInfo;
  const insured = policy?.insured;
  const topBarClaimInfo: Record<string, InfoItem> = {};

  if (!isEmpty(insured)) {
    const fullName = buildFullName(insured);
    if (fullName) {
      topBarClaimInfo.policyholder = createInfoItem('Policyholder', fullName);
    }
  }

  if (!topBarClaimInfo.policyholder) {
    topBarClaimInfo.policyholder = createInfoItem('Policyholder', 'N/A');
  }
  topBarClaimInfo.policyNumber = createInfoItem('Policy Number', policy?.number || '');
  topBarClaimInfo.dateOfLoss = createInfoItem('Date of Loss', date_of_loss || '');
  topBarClaimInfo.status = createInfoItem('Status', status, status);

  return topBarClaimInfo;
};
